import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const ExamGroupService = sdk.getService('ExamGroupService');

export const useExamGroupOptions = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['exam-groups', 'by-academy'],
    queryFn: () => ExamGroupService.getExamGroupsByAcademyForSelector()
  });
  return { data, isLoading, error };
};
